import React, { useEffect, useState, useRef } from "react";
import { Box, Card, CardContent, Typography, Divider, Button, CircularProgress } from "@mui/material";
import RoomIcon from "@mui/icons-material/Room";
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import StarIcon from "@mui/icons-material/Star";
import styles from "./styles.module.css";
import Logo from '../../../app/assets/logo-small.svg'
import theme from "../../../theme/theme";
import { ThemeProvider } from "@mui/material/styles";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import EuroOutlinedIcon from '@mui/icons-material/EuroOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import LocalParkingOutlinedIcon from '@mui/icons-material/LocalParkingOutlined';
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import { useNavigate, useParams } from 'react-router-dom';
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import he from 'he';
import { clinicRegistration } from "../../../JsonForms/ClinicRegistration";
import { axiosProxyInstance } from "../../../utils/request";
import { useJsApiLoader } from '@react-google-maps/api';

const ClinicProfile = () => {
  const { isLoaded } = useJsApiLoader({
      googleMapsApiKey: process.env.REACT_APP_MAP_KEY,
      libraries: ['places'],
  });
  const navigate = useNavigate();
  const { clinicId } = useParams();
  const services = clinicRegistration.sections.find((value) => value.sectionName === 'Area of Speciality').fields
  const serviceArray = services[0].options;
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [center, setCenter] = useState({
    lat: null,
    lng: null
  });
  const treatments = details?.data?.treatments_v2;

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await axiosProxyInstance.get(`/listing/${clinicId}?post_status=all`);
        setDetails(response.data.data ?? []);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch listings");
        setLoading(false);
      }
    };
    fetchDetails();
  }, []);

  const geocodeAddress = (address) => {
    if (!window.google || !window.google.maps) return;

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const location = results[0].geometry.location;
        const mapData = {
          lat: location.lat(),
          lng: location.lng()
        };
        setCenter(mapData);
      } else {
        console.error('Geocode error:', status);
      }
    });
  };

  useEffect(() => {
    if(details?.data){
      if(details?.data?.latitude && details?.data?.longitude){
        const mapData = {
          lat: Number(details?.data?.latitude),
          lng: Number(details?.data?.longitude)
        };
        setCenter(mapData);
      }else{
        if(isLoaded && details?.data?.location?.length){
          const fullAddress = details?.data?.location.filter(Boolean).join(', ');
          geocodeAddress(fullAddress);
          // const coords = await geocodeAddress(fullAddress);
        }
      }
    }
  }, [details, isLoaded]);

  // const center = {
  //   lat: Number(details?.data?.latitude),
  //   lng: Number(details?.data?.longitude),
  // }
  const clinicCardRef = useRef(null);
  const [clinicCardHeight, setClinicCardHeight] = useState(150);

  useEffect(() => {
    if (clinicCardRef.current) {
      setClinicCardHeight(clinicCardRef.current.clientHeight);
    }
  }, []);

  const containerStyle = {
    width: "100%",
    height: "300px",
  };

  const allDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const dayMap = {
    Mon: "Monday",
    Tue: "Tuesday",
    Wed: "Wednesday",
    Thu: "Thursday",
    Fri: "Friday",
    Sat: "Saturday",
    Sun: "Sunday",
  };

  const formatTime = (timeStr) => {
    const [hour, minute] = timeStr.split(":").map(Number);
    const isPM = hour >= 12;
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minute.toString().padStart(2, "0")} ${isPM ? "PM" : "AM"}`;
  };

  const getOpeningHours = (openingHours) => {
    const hoursMap = {};
    // openingHours?.forEach((entry) => {
    //   entry?.days?.forEach((shortDay) => {
    //     hoursMap[dayMap[shortDay]] = `${formatTime(entry.from)} - ${formatTime(entry.to)}`;
    //   });
    // });

    openingHours?.forEach(slot => {
      slot.days?.forEach(day => {
        if (!hoursMap[dayMap[day]]) {
          hoursMap[dayMap[day]] = [];
        }
        hoursMap[dayMap[day]].push(`${formatTime(slot.from)} - ${formatTime(slot.to)}`);
      });
    });

    return hoursMap;
  };
  const hours = getOpeningHours(details?.data?.opening_hours);
  
  const fullStars = Math.floor(details?.data?.rating?.ratingValue);
  const maxStars = 5;
  
  return (
    <ThemeProvider theme={theme}>
      <Box className={styles.container}>
        <Box className={styles.headerContainer}>
          <Box className={styles.header}>
            <Box className={styles.logoContainer}>
              <img src={Logo} alt="Logo" />
            </Box>
            <Button variant="contained" className={styles.exitButton} onClick={() => navigate('/practitioner/listing')}>
              Exit Preview
            </Button>
          </Box>
        </Box>
        {/* <Box className={styles.clinicDetails}> */}
          <Card ref={clinicCardRef} className={styles.clinicCard}>
            {loading ? (
              <Box className={styles.loaderContainer}>
                <CircularProgress className={styles.loader} />
              </Box>
            ) : (
              <>
                <Box className={styles.clinicInfo}>
                  <Box className={styles.clinicImage}>
                    <img className={styles.clinicImage} src={details?.data?.logo} />
                  </Box>
                  <CardContent className={styles.cardContent}>
                    <Typography variant="gothamXL" className={styles.clinicName}>{details.post_title} </Typography>
                    {/* <Box className={styles.rating}>
                      {[...Array(maxStars)].map((_, i) =>
                        i < fullStars ? (
                          <StarIcon key={i} className={styles.starIcon} />
                        ) : (
                          <StarIcon key={i} className={styles.disabledStarIcon} />
                        )
                      )}
                      <Typography className="gothamSmall">
                        <span className={styles.ratingStar}> {details?.data?.rating?.ratingValue.toFixed(1)}</span>
                        <span className={styles.ratingNumber}> ({details?.data?.rating?.totalVotes})</span>
                      </Typography>
                    </Box> */}
                    <Typography variant="gothamSmall" className={styles.address}>
                      <RoomIcon className={styles.addressIcon} /> {details?.data?.full_address}
                    </Typography>
                    <Box className={styles.callBox}>
                      <Typography variant="gothamSmall" className={styles.phone}>
                        <PhoneOutlinedIcon className={styles.icon} /> Call to book: <span className={styles.phoneNumber}>{details?.data?.phone?.formatted}</span>
                      </Typography>
                    </Box>
                  </CardContent>
                </Box>
                <Box className={styles.mapContainer}>
                  {
                    isLoaded && center?.lat && center?.lng && (
                      // <LoadScript googleMapsApiKey={process.env.REACT_APP_MAP_KEY}>
                        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={10}>
                          <Marker position={center} />
                        </GoogleMap>
                      // </LoadScript>
                    )
                  }
                </Box>
              </>
            )}
          </Card>
          <Box className={styles.detailsContainer}>
            <Box className={styles.leftSection}>
              <Typography variant="gothamMedium" className={styles.breadcrumb}>
                {details?.seo?.breadcrumbs?.map((breadcrumb) => (
                  <> {he.decode(breadcrumb?.text)} <ChevronRightIcon fontSize="small" /></>
                ))}
              </Typography>
              <Typography variant="gothamXL" className={styles.sectionTitle}>{details.post_title}</Typography>
              <Typography variant="gothamMedium" className={styles.description} dangerouslySetInnerHTML={{ __html: details?.data?.description || '' }} />
              <Typography variant="gothamXL" className={styles.areaSectionTitle}>Areas of Specialty</Typography>
              <Box className={styles.specialtiesContainer}>
                {Object.values(details?.data?.services_v2 || {})?.map((specialty, index) => {
                  const specialtyTagData = serviceArray[specialty]?.options.filter((specialtyData) => {
                    if (Object.values(treatments || {}).includes(specialtyData)) {
                      return specialtyData
                    }
                  }) ?? [];
                  return (
                    <Box key={index} className={styles.specialties}>
                      <HomeOutlinedIcon className={styles.homeIcon} />
                      <Typography variant="gothamLarge" className={styles.specialtyItem}>
                        {specialty}
                      </Typography>
                      <Box className={styles.specialtyTags}>
                        {specialtyTagData.map((specialtyVal) => (
                          <span>{specialtyVal}</span>
                        ))}
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
            {/* Divider */}
            <Divider orientation="vertical" flexItem className={styles.divider} />

            {/* Right Section */}
            <Box className={styles.rightSection}>
              <Typography variant="gothamMedium" className={styles.sectionTitle}> <EuroOutlinedIcon className={styles.rightSectionIcon} />Appointment Costs</Typography>
              <Typography variant="gothamMedium" className={styles.detailItemAsses}>Initial Assessment <span>{details?.data?.initial_appointment_time} mins - £{details?.data?.initial_appointment_cost}</span></Typography>
              <Typography variant="gothamMedium" className={styles.detailItemAsses}>Follow-up treatment: <span>{details?.data?.subsequent_appointment_time} mins - £{details?.data?.subsequent_appointment_cost}</span></Typography>

              <Typography variant="gothamMedium" className={`${styles.sectionTitle} ${styles.marginTop30}`}> <AccessTimeOutlinedIcon className={styles.rightSectionIcon} /> Opening Hours</Typography>
              {allDays?.map((day) => (
                <Typography key={day} variant="gothamMedium" className={styles.detailItem}>
                  {
                    <Box style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                      <Box>{day}</Box>
                      <Box style={{flex: 1}}>
                        {
                          hours[day]
                          ?(
                            <>
                              {
                                hours[day]?.map((item, itemIndex) => (
                                  <div style={{textAlign: 'right', marginBottom: itemIndex === hours[day]?.length - 1 ? '0px': '10px'}} key={`${item}-${itemIndex}`}>{item}</div>
                                ))
                              } 
                            </>
                          ):(
                            <div style={{textAlign: 'right'}}>Closed</div>
                          )
                        }
                      </Box>
                    </Box>
                  }
                  {/* {day} <span>{hours[day] || "Closed"}</span> */}
                </Typography>
              ))}
              <Typography variant="gothamMedium" className={`${styles.sectionTitle} ${styles.marginTop30}`}><LocalParkingOutlinedIcon className={styles.rightSectionIcon} /> Parking</Typography>
              <Typography variant="gothamMedium" className={styles.detailItem}>
                {Object.values(details?.data?.parking || {}).map((parking) => (
                  <span>{parking}</span>
                ))}
              </Typography>

              <Typography variant="gothamMedium" className={`${styles.sectionTitle} ${styles.marginTop30}`}><LocalParkingOutlinedIcon className={styles.rightSectionIcon} /> Accessible Access</Typography>
              <Typography variant="gothamMedium" className={styles.detailItem}>{details?.data?.accessible_access || 'No'}</Typography>

              <Typography variant="gothamMedium" className={`${styles.sectionTitle} ${styles.marginTop30}`}><HealthAndSafetyOutlinedIcon className={styles.rightSectionIcon} /> Health Insurances Accepted</Typography>
              {Object.values(details?.data?.health_insurances_accepted || {})?.map((insurance) => (
                <Typography variant="gothamMedium" className={styles.detailItem}>{insurance}</Typography>
              ))}
            </Box>
          {/* </Box> */}
        </Box>
      </Box>
    </ThemeProvider >
  );
};

export default ClinicProfile;
